namespace Umbrella.Modules.Colleagues {
    @Pipe('Colleagues', 'isAvailable')
    class IsAvailableFilter {
        public transform(available: Availability | string | number) {
            switch (available) {
                case Availability.Available:
                case 'Available':
                case 1:
                    return true;
                default:
                    return false;
            }
        }
    }
}
